import React from 'react';
import {Button} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {store} from "../store";

const useStyles = makeStyles({
    root: {
        background: "#92363B",
        marginTop: "10px",
        border: 0,
        borderRadius: 3,
        // boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
        color: "white",
        height: 48,
        padding: "0 30px",
        "&:hover": {
            background: "#652828",
        },
    },
});

const BackToStart = (props) => {
    const buttonStyles = useStyles();
    const globalState = React.useContext(store);
    const {setState: setGlobalState} = globalState;

    const backToStart = (e) => {
        e.preventDefault();
        setGlobalState({_path: "progress", _value: "lookup"});
        setGlobalState({_path: "amount", _value: 0});
        setGlobalState({_path: "account.number", _value: false});
        setGlobalState({_path: "account.balance", _value: 0});
    };

    return (
        <div>
            <Button
                variant="contained"
                onClick={backToStart}
                className={buttonStyles.root}
            >
                {props.children}
            </Button>
        </div>
    );
};

export default BackToStart;
